import React from 'react'
import StepBar from '../../atoms/StepBar/StepBar'

const StatoOrdineStepBar = ({ tipo_ordine, stato_ordine_calcolato, servicegift }) => {
  const NEUTRO = 'neutro'
  const PERSONALIZZATO = 'personalizzazione'
  const ALTRO = 'Altro'
  const SIPEC = 'Sipec'
  const personalizzatoSteps = (
    servicegift ? [{ statoOrdineCalcolato: ['IN_ATTESA'], label: 'In attesa di approvazione' }] : []
  ).concat([
    { statoOrdineCalcolato: ['TRASMESSO', 'BOZZE_DA_CARICARE'], label: 'Trasmesso' },
    { statoOrdineCalcolato: ['BOZZE_INVIATE'], label: 'Inviata bozza digitale' },
    { statoOrdineCalcolato: ['BOZZE_APPROVATE'], label: 'Approvata bozza digitale' },
    { statoOrdineCalcolato: ['IN_LAVORAZIONE'], label: 'In lavorazione' },
    { statoOrdineCalcolato: ['ORDINE_EVASO'], label: 'Emesso DDT' },
  ])
  const neutroSteps = servicegift
    ? [
        { statoOrdineCalcolato: ['IN_ATTESA'], label: 'In attesa di approvazione' },
        { statoOrdineCalcolato: ['TRASMESSO'], label: 'Trasmesso' },
        { statoOrdineCalcolato: ['ORDINE_EVASO'], label: 'Emesso DDT' },
      ]
    : [
        { statoOrdineCalcolato: ['TRASMESSO'], label: 'Trasmesso' },
        { statoOrdineCalcolato: ['IN_PREPARAZIONE'], label: 'In preparazione' },
        { statoOrdineCalcolato: ['ORDINE_EVASO'], label: 'Emesso DDT' },
      ]
  const steps =
    tipo_ordine === PERSONALIZZATO
      ? !servicegift
        ? personalizzatoSteps
        : servicegift.personalizzazione_type === ALTRO
        ? neutroSteps
        : servicegift.personalizzazione_type === SIPEC
        ? personalizzatoSteps
        : []
      : tipo_ordine === NEUTRO
      ? neutroSteps
      : []
  const currentStep = steps.findIndex((step) =>
    step.statoOrdineCalcolato.includes(stato_ordine_calcolato)
  )

  if (!steps.length) return null

  return (
    <StepBar
      stepsLabels={steps.map((step) => step.label)}
      currentStep={currentStep >= 0 ? currentStep + 1 : null}
      navActive
    />
  )
}

export default StatoOrdineStepBar
